<template>
  <md-card>
    <md-card-header data-background-color="secondary">
      <h4 class="title">Enter your business's ABN or ACN</h4>
    </md-card-header>
    <md-card-content>
      <md-field class="mb-4">
        <label>ABN/ACN</label>
        <md-input
          v-model.trim="abn"
          v-mask="'###########'"
          type="text"
          @input="business = undefined"
          @keydown.enter="search()"
        ></md-input>
        <md-button
          class="md-flat md-secondary"
          :disabled="!searchEnabled"
          @click="search()"
        >
          Search
        </md-button>
      </md-field>
      <div v-if="business">
        <span class="d-block fw-bold">{{ business.business_name }}</span>
        <span class="d-block">{{ business.trading_name }}</span>
        <div class="d-flex mb-3 float-end align-items-center">
          <md-progress-spinner
            class="mx-3"
            :md-diameter="30"
            :md-stroke="loading ? 4 : 0"
            md-mode="indeterminate"
          ></md-progress-spinner>
          <md-button class="md-primary" :disabled="loading" @click="join()">
            Join Business
          </md-button>
        </div>
      </div>
      <div v-else-if="business === null">
        <span class="d-block fw-bold">{{ lookupName }}</span>
        <span class="d-block">{{ noBusinessMsg }}</span>
        <md-button
          class="md-primary float-end"
          :disabled="!validAbn"
          @click="$emit('reg', abn, lookupName)"
        >
          Register Business
        </md-button>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import ApiService from "@/services/api";

export default {
  name: "BusinessLookupCard",
  data() {
    return {
      abn: "",
      lookupName: "",
      business: undefined,
      loading: false,
      validAbn: false
    };
  },
  computed: {
    searchEnabled() {
      return this.abn.length >= 9;
    },
    noBusinessMsg() {
      return this.lookupName
        ? "This business has not been registered."
        : "No business was found with the given ABN/ACN.";
    }
  },
  methods: {
    search() {
      if (!this.searchEnabled) return;

      ApiService.business
        .findByAbn(this.abn)
        .then(response => {
          this.business = response.data.data.business;
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.business = null;
            if (error.response.data.data.lookup_matched) {
              this.lookupName = error.response.data.data.lookup_name;
              this.validAbn = true;
            } else {
              this.lookupName = "";
              this.validAbn = false;
            }

            this.$toast.info(this.noBusinessMsg);
          } else {
            this.$toast.error("An unknown error occurred.");
          }
        });
    },
    join() {
      if (this.loading) return;
      this.loading = true;

      ApiService.business
        .join(this.business.id)
        .then(() => {
          this.$toast.success("You have joined the business.");

          this.$store.dispatch("getAuthUser").then(() => {
            const user = this.$store.getters.authUser;
            this.$set(user, "new_pass", {
              name: "",
              price: 0,
              type: "none"
            });
            this.$store.dispatch("setCart", [user]).then(() => {
              this.$router.push("/cart");
            });
          });
        })
        .catch(() => {
          this.$toast.error("Failed to join business.");
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style scoped></style>
